export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
export const TOKEN = 'TOKEN'
export const PATIENT_TOKEN = 'PATIENT_TOKEN'


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/auth/types.js
// module id = null
// module chunks = 